import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';

import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isUserLogged()) {
    return true;
  } else {
    router.navigate(['/inicio-sesion']);
    return false;
  }
};

export const adminGuard: CanMatchFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.doesUserHasRole(['SUPERADMIN', 'ADMIN'])) {
    return true;
  } else {
    router.navigate(['/carrito']);
    return false;
  }
};
